import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import Link from 'components/Link';
import ImageV2 from 'components_v2/common/ImageV2';
import PopupOverlay from 'components_v2/common/PopupOverlay/PopupOverlay';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import s from './BannerSlider.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class BannerSlider extends React.Component {
  constructor() {
    super();
    this.state = {
      showBannerPopup: false,
      banner: null,
    };
  }
  loadSection = () => {
    const { data = {}, onRendered } = this.props;
    if (data && data.dataUrl) {
      this.loadSectionData(data.dataUrl, onRendered);
    }
  };

  handleClosePopup = () => {
    this.setState({
      showBannerPopup: false,
    });
  };

  handleBannerClick = banner => {
    this.setState({
      banner,
      showBannerPopup: true,
    });
  };

  renderPopupImage = () => (
    <PopupOverlay
      position="center"
      closeCallback={this.handleClosePopup}
      show={this.state.showBannerPopup}
      blackOverlayEnabled
    >
      <div className={s.popupImage}>
        <ImageV2
          msid={this.state.banner.imageid}
          resizemode={4}
          imgsize={this.state.banner.imagesize}
          width={1200}
          alt={this.state.banner.hl}
          title={this.state.banner.title || ''}
          placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
          lazyload
        />
      </div>
    </PopupOverlay>
  );

  loadSectionData = (dataUrl, cb) => {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          this.setState(
            {
              data: { ...this.props.data, ...data.data },
            },
            cb,
          );
        }
      });
  };
  render() {
    const { gaAction, gaLabelPerfix, ga4Type, ga4Category } = this.props;
    const data = this.state.data || this.props.data;
    const bannerWidth = data.bannerWidth || this.props.bannerWidth;
    const noMarginTop = data.noMarginTop || false;
    const className = data.className || this.props.className;
    return (
      <>
        {this.props?.data?.usePopupPortal &&
          this.state?.banner &&
          this.state.showBannerPopup &&
          this.state.banner?.imageid &&
          this.renderPopupImage()}
        <InViewObserver
          inViewCallback={() => {
            this.loadSection();
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: `${ga4Type}`,
                category: `${ga4Category || ''}`,
              });
            }
          }}
          viewMargin="300px 0px 300px 0px"
        >
          {data && Array.isArray(data.items) && data.items.length > 0 ? (
            <div
              className={`${s.bannerSlider} ${className} ${data.className} ${
                noMarginTop ? s.noMarginTop : ''
              }`}
            >
              <Listingheader
                headingname={data.name}
                headingLink={data.path}
                newga={`${data.name}Section_Actions#HeadingClick`}
              />
              <div className={s.sliderBlk}>
                {data.items.map(
                  (obj, index) =>
                    !(data.theme && data.theme === 'nolinkonslide') &&
                    obj.wu !== 'undefined' &&
                    obj.wu ? (
                      <Link
                        to={obj.wu}
                        doNotChangeDomain={
                          (obj && obj.dnc) ||
                          !!(data.id && data.id === 'schooling_banner_widget')
                        }
                        data-newga={
                          obj.gaData ||
                          `${gaAction}#${gaLabelPerfix}${index + 1}/${obj.wu}`
                        }
                        target={obj.target === '_blank' ? obj.target : ''}
                        ga4Data={
                          ga4Type && [
                            {
                              event: 'user_click',
                              type: `${
                                className === 'insertSlider'
                                  ? 'main_line_up'
                                  : ga4Type
                              }`,
                              label: `banner`,
                              category: `story_click`,
                              story_no: `${index + 1}`,
                              msid: obj?.id,
                            },
                          ]
                        }
                      >
                        <ImageV2
                          lazyload={!(index <= 1)}
                          key={index}
                          msid={obj.imageid}
                          resizemode={4}
                          imgsize={obj.imagesize}
                          alt={obj.hl}
                          isInlineImage={data?.notThumbUrl || false}
                          width={bannerWidth}
                          title={obj.title || ''}
                          //placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                        />
                      </Link>
                    ) : (
                      // eslint-disable-next-line jsx-a11y/anchor-is-valid
                      <Link
                        onClick={e => {
                          e.preventDefault();
                          if (this.props?.data?.usePopupPortal) {
                            this.handleBannerClick(obj);
                          }
                        }}
                        className={`${s.fakeLink} ${
                          data?.theme === 'nolinkonslide' ? s.withborder : ''
                        }`}
                      >
                        <ImageV2
                          lazyload={!(index <= 1)}
                          key={index}
                          msid={obj.imageid}
                          resizemode={4}
                          imgsize={obj.imagesize}
                          alt={obj.hl}
                          isInlineImage={data?.notThumbUrl || false}
                          width={bannerWidth}
                          title={obj.title || ''}
                          //placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                        />
                      </Link>
                    ),
                )}
              </div>
            </div>
          ) : (
            ''
          )}
        </InViewObserver>
      </>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

BannerSlider.propTypes = {
  data: PropTypes.shape({}),
  bannerWidth: PropTypes.number,
  gaAction: PropTypes.string,
  gaLabelPerfix: PropTypes.string,
  onRendered: PropTypes.func,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};
BannerSlider.defaultProps = {
  data: {},
  bannerWidth: 368,
  gaAction: '',
  gaLabelPerfix: '',
  onRendered() {},
  className: '',
  isMobile: false,
  ga4Type: '',
  ga4Category: '',
};

export default connect(mapStateToProps)(BannerSlider);
